import { Link } from "react-router-dom";
import { BrandLockup } from "@/components/brand/Logo";
import { cn } from "@/lib/utils";

export const authInput =
  "h-12 w-full rounded-xl border border-white/10 bg-ink-850 px-4 text-[15px] text-white placeholder:text-zinc-600 transition-colors focus:border-white/25 focus:outline-none";

export const authButton =
  "inline-flex h-12 w-full items-center justify-center rounded-xl bg-white text-[15px] font-medium text-ink-950 transition-[opacity,transform] hover:bg-white/90 active:scale-[0.99] disabled:opacity-40";

export function AuthLayout({ title, subtitle, children, footer, testId }) {
  return (
    <div className="flex min-h-dvh bg-ink-950 text-zinc-100" data-testid={testId}>
      <div className="relative hidden w-[44%] max-w-[620px] flex-col justify-between border-r border-white/[0.06] bg-ink-900 p-12 lg:flex">
        <Link to="/" aria-label="ChatSleek">
          <BrandLockup size={30} />
        </Link>
        <div className="cs-rise">
          <p className="text-[2.6rem] font-semibold leading-[1.1] tracking-tight text-white">
            You ask.
            <br />
            <span className="text-zinc-500">ChatSleek figures out the rest.</span>
          </p>
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-zinc-500">
            One assistant for thinking, writing and building — it picks the right AI for each request so you don't have to.
          </p>
        </div>
        <p className="text-xs text-zinc-600">© {new Date().getFullYear()} ChatSleek</p>
      </div>
      <div className="flex flex-1 flex-col px-5 py-8 sm:px-10">
        <div className="lg:hidden">
          <BrandLockup size={28} />
        </div>
        <div className="mx-auto flex w-full max-w-[400px] flex-1 flex-col justify-center py-10 cs-rise">
          <h1 className="text-[1.75rem] font-semibold tracking-tight text-white">{title}</h1>
          {subtitle && <p className="mt-2 text-[15px] text-zinc-400">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-sm text-zinc-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function FormError({ children, testId = "auth-form-error", className }) {
  if (!children) return null;
  return (
    <div className={cn("rounded-xl border border-rose-400/20 bg-rose-500/[0.06] px-3.5 py-2.5 text-sm text-rose-200", className)} role="alert" data-testid={testId}>
      {children}
    </div>
  );
}

export function FormNotice({ children, testId = "auth-form-notice" }) {
  if (!children) return null;
  return (
    <div className="rounded-xl border border-white/10 bg-ink-850 px-3.5 py-2.5 text-sm text-zinc-300" role="status" data-testid={testId}>
      {children}
    </div>
  );
}
